import { render, staticRenderFns } from "./GlobalDashboardCard.vue?vue&type=template&id=09028dfd&scoped=true&"
import script from "./GlobalDashboardCard.vue?vue&type=script&lang=js&"
export * from "./GlobalDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDashboardCard.vue?vue&type=style&index=0&id=09028dfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09028dfd",
  null
  
)

export default component.exports